<template>
   <el-form :model="convForm" inline :rules="convRules" label-width="100px">
        <el-row>
          <el-col :span="8" >
             <el-form-item label="竞价目标">
              <el-radio-group v-model="target" size="mini"  @change="(value)=>$emit('formchange', value)">
                <el-radio-button 
                  v-for="item in targetList"
                  :label="item.value"
                  :key="item.value"
                >
                  {{item.label}}
                </el-radio-button>
              </el-radio-group>
             </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" >
             <el-form-item label="计费方式" required>
              <el-radio-group @change="triggerPriceTip" :value="way" size="mini" @input="(data)=>$emit('update:way', data)" >
                <el-radio-button 
                  v-for="item in wayList" 
                  :key="item" 
                  :label="item"
                />
              </el-radio-group>
             </el-form-item>
          </el-col>
         <el-col :span="10">
            <el-form-item label="一阶段出价" prop="price_1">
              <el-input 
                v-model="convForm.price_1" 
                style="width:205px" 
                placeholder="请输入一阶段出价"
                @input="(value)=>handleValidNumber(value, 'price_1')"
              />
            </el-form-item>
             <div class="form-item__tip" v-if="showPrice_1Tip">
              <TipInfo :data="priceAvg"/>
            </div>
          </el-col>
        </el-row>
      </el-form>
</template>

<script>
import { validNum } from '@/utils/validate'
import TipInfo from './tipInfo.vue'
export default {
  components: { TipInfo },
  props: ['dTarget', 'formData', 'targetList', 'way', 'wayList', 'conversionPriceData', 'validNumber'],
  data() {
      const validateNum =  (rule, value, callback) => {
        if (validNum(value)) {
          if (value>=0.01&&value<5000) {
            callback()
          }else {
              this.showPrice_1Tip = false
             callback(new Error('请输入大于等于0.01和小于5千的数'))
          }
        }else {
           this.showPrice_1Tip = false
          callback(new Error('请输入非负数字'))
        }
      };
    const {  price_1 =0.1 } = this.formData
    return {
      target: this.dTarget,
      showPrice_1Tip: false,
      priceAvg: '',//一阶段
      convForm: {
        price_1,
      },
      convRules: {
        price_1: [
           { required: true,  validator: validateNum, trigger: 'change' }
        ],
      }
    }
  },
  watch: {
    convForm: {
      handler(n) {
        this.$emit('updateForm', {...n})
      },
      immediate: true,
      deep: true
    },
    target() {
       this.$emit('updateForm', {...this.convForm})
    }
    
  },
  methods: {
    handleValidNumber(value, key, type) {
      const num = this.validNumber(value);
      this.handleShowTip(num || value)
      if (num) {
        this.convForm[key] = num
      }
    },
    // 显示均价提示
    async handleShowTip(value) {
      if (value&&validNum(value)) {
         this.showPrice_1Tip = true
        const params = {
            type: 'cpx_bid',
            value
        }
        this.priceAvg = ''
        this.conversionPriceData(params, (data)=> {
          this.priceAvg = data
        })
      }else {
         this.showPrice_1Tip =false
      }
    },
    triggerPriceTip() {
      this.showPrice_1Tip = true
      this.handleShowTip(this.convForm.price_1)
    }
  }
}
</script>

<style lang="scss" scoped>
 .form-item__tip {
     margin-top: -16px;
    margin-left: 28px;
    color: #666;
    font-size: 12px;
 }
</style>